import ReactDOM from "react-dom";

interface OneTimePaymentTypeModalProps {
  open: boolean;
  onClose: () => void;
  onSelectCash: () => void;
  onSelectCard: () => void;
}

export default function OneTimePaymentTypeModal({
  open,
  onClose,
  onSelectCash,
  onSelectCard,
}: OneTimePaymentTypeModalProps) {
  if (!open) return null;

  return ReactDOM.createPortal(
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex min-h-screen items-center justify-center p-4">
        {/* Backdrop */}
        <div
          className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
          onClick={onClose}
        />

        {/* Modal */}
        <div className="relative bg-white dark:bg-gray-800 rounded-lg shadow-xl max-w-md w-full p-6">
          <div className="text-center mb-6">
            <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">
              One Time Payment
            </h3>
            <p className="text-sm text-gray-500 dark:text-gray-400">
              How would you like to record this payment?
            </p>
          </div>

          <div className="space-y-3">
            {/* Cash/Manual Payment Button */}
            <button
              onClick={onSelectCash}
              className="w-full flex items-center justify-center gap-3 px-6 py-4 bg-green-50 dark:bg-green-900/20 border-2 border-green-200 dark:border-green-800 rounded-lg hover:bg-green-100 dark:hover:bg-green-900/30 transition-colors group"
            >
              <span className="text-3xl">💵</span>
              <div className="text-left">
                <div className="font-semibold text-gray-900 dark:text-white group-hover:text-green-700 dark:group-hover:text-green-300">
                  Cash/Manual Payment
                </div>
                <div className="text-xs text-gray-500 dark:text-gray-400">
                  Record cash, check, Venmo, etc.
                </div>
              </div>
            </button>

            {/* Card Payment Button */}
            <button
              onClick={onSelectCard}
              className="w-full flex items-center justify-center gap-3 px-6 py-4 bg-blue-50 dark:bg-blue-900/20 border-2 border-blue-200 dark:border-blue-800 rounded-lg hover:bg-blue-100 dark:hover:bg-blue-900/30 transition-colors group"
            >
              <span className="text-3xl">💳</span>
              <div className="text-left">
                <div className="font-semibold text-gray-900 dark:text-white group-hover:text-blue-700 dark:group-hover:text-blue-300">
                  Card Payment (Stripe)
                </div>
                <div className="text-xs text-gray-500 dark:text-gray-400">
                  Process credit/debit card payment
                </div>
              </div>
            </button>
          </div>

          {/* Cancel Button */}
          <button
            onClick={onClose}
            className="mt-4 w-full px-4 py-2 text-sm text-gray-700 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white transition-colors"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}

